import { SplitsLink } from '~/components/Link'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { useAuth } from '~/context/AuthProvider'
import { useKycStatus } from '~/hooks/useKycStatus'
import { useNavigation } from '~/hooks/useNavigation'

export const SetupBankTransfersDialog = ({
  isOnramp,
}: {
  isOnramp?: boolean
}) => {
  const { closeGlobalModal } = useAuth()
  const navigate = useNavigation()
  const { isKycComplete, isKycPending, isKycRejected } = useKycStatus()

  const title = isKycComplete
    ? 'Add bank account'
    : isKycRejected
      ? 'Verification rejected'
      : isKycPending
        ? 'Verification pending'
        : isOnramp
          ? 'Onramp'
          : 'Offramp'

  const buttonText = isKycComplete
    ? 'Add bank account'
    : isKycPending || isKycRejected
      ? 'View status'
      : 'Begin verification'

  return (
    <SplitsDialogContent
      title={title}
      variant="cta"
      id="setup-bank-transfers"
      actionButton={{
        text: buttonText,
        onClick: () => {
          navigate('/settings/team/banks')
          closeGlobalModal()
        },
      }}
    >
      {isKycComplete ? (
        <p>
          You&apos;ve completed verification. Add a bank account to enable
          offramps.
        </p>
      ) : isKycRejected ? (
        <p>
          Your verification was rejected. Visit the banks settings page to view
          details or contact support.
        </p>
      ) : isKycPending ? (
        <p>
          Your verification is still in progress. We&apos;ll email you when
          approved, usually within 1 business day for KYC and 1 week for KYB.
        </p>
      ) : (
        <p>
          Move money from {isOnramp ? 'your bank accounts' : 'Splits'} to{' '}
          {isOnramp ? 'Splits' : 'your bank accounts'}. To enable this, you will
          need to verify your entity (KYB or KYC).{' '}
          <SplitsLink
            path="https://splits.org/docs/banking#getting-verified"
            target="tab"
            className="underline"
          >
            Learn more
          </SplitsLink>
          .
        </p>
      )}
    </SplitsDialogContent>
  )
}
